import { Box } from "@chakra-ui/react";

export const Gap = ({ direction = "vertical", gap = 8 }: { direction?: "vertical" | "horizontal"; gap?: number }) => {
  const style = {
    [direction === "vertical" ? "my" : "mx"]: gap,
  };
  return <Box {...style} />;
};
